// tokenReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	confirmationPopup: {
    isOpen: false,
    result: {
      type: '',
      message: '',
    },
    setOpen: false,
    }
};

const confirmationPopupReducer = createSlice({
	name: 'confirmationPopup', // Use the same name as in your store configuration
	initialState,
	reducers: {
		setConfirmationPopup: (state, action) => {
			state.confirmationPopup = action.payload;
		},
	},
});

export const { setConfirmationPopup } = confirmationPopupReducer.actions;
export default confirmationPopupReducer.reducer;
